import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function MobileMenuPortal({ children }: { children: React.ReactNode }) {
  const [host, setHost] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let el = document.getElementById("mmm-root") as HTMLElement | null;
    if (!el) {
      el = document.createElement("div");
      el.id = "mmm-root";
      document.body.appendChild(el);
    }
    setHost(el);
    // IMPORTANTE: sem cleanup removendo o el (evita loop em StrictMode)
  }, []);

  if (!host) return null;
  return createPortal(children, host);
}
